import { ToastContext, ToastContextProps } from '@shared/libs/context/ToastContext';
import { useContext } from 'react';

export const useToast = (): ToastContextProps => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error('useToast must be used within an ToastContext');
  }

  return context;
};
